export const TEXT = {
    MY_EVENTS: 'My Events',
    UPCOMING_EVENTS: 'Upcoming Events',
    PAST_EVENTS: 'Past Events'
}